module.exports = __webpack_public_path__ + "static/media/p50v2.4b15a7a2.gif";